import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { License } from '../../../stores/types';
import { MODAL_TYPES, MenuItem, useGlobalModalContext } from '../../_ui';
import AssignLicense from '../assign-license/AssignLicenseComponent';
import { LICENSE_STATUS } from '../utils';

interface AssignLicenseMenuItemProps {
  license: License;
}

export const AssignLicenseMenuItem: React.FC<AssignLicenseMenuItemProps> = ({ license }) => {
  const { showModal } = useGlobalModalContext();
  const { t } = useTranslation();

  const handleAssignLicense = useCallback(() => {
    showModal(MODAL_TYPES.INFO_MODAL, {
      title: t('license_assign'),
      height: 'max-content',
      bodyStyleClass: 'flex-grow',
      onRenderBody: () => <AssignLicense license={license} />,
      shouldCloseOnOverlayClick: false,
    });
  }, [showModal, t, license]);

  const licenseStatusUnassigned = (row: License) => {
    return row.status?.toLowerCase() === LICENSE_STATUS.UNASSIGNED.toLowerCase();
  };

  return licenseStatusUnassigned(license) ? (
    <MenuItem
      label={t('license_assign')}
      dataTestId='license_assign'
      onClick={handleAssignLicense}
    />
  ) : null;
};
